jQuery(document).ready(function ($) {

    convertToCallableNumbers('landline', 'Landline: ');
    convertToCallableNumbers('mobile', 'Mobile Number: ');



    function convertToCallableNumbers(dom, label) {

        $('[data-' + dom + ']').each(function (index, element) {
            var rawStr = $(this).data(dom);
            var contactNumbersLabel = rawStr.split('; ');
            var contactNumber = rawStr.replace(/ /g, "").replace(/[\(\)']+/g, '').split(';');

            if ($('body').hasClass('page-template-template-contact') && dom === 'mobile') {
                $(this).html('Viber: ')
            } else {
                $(this).html(label);
            }

            // console.log()

            for (var i = 0; i < contactNumbersLabel.length; i++) {
                var semicolon = i + 1 < contactNumbersLabel.length ? ', ' : '';
                $(this).append(`<a class="text-link text-color--black" href="tel:` + contactNumber[i] + `">` + contactNumbersLabel[i] + semicolon + `</a>`);
            }
        })
    }
});